import {DetailTable} from '../../mapping-classes/detail-table';

export class Costs implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(costs: any) {
    if (!costs || !costs.costsDetails || costs.costsDetails.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = costs.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(costs.costsDetails);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen kostenarrangement transacties.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'txGroup',
      'txGroupDescription',
      'currentRate',
      'minimum',
    ];
  }

  setRowData(costsDetails) {
    costsDetails.forEach((details) => {
      let first = true;
      details.levelDetails.forEach((levelDetail) => {
        if (this.restrictedData) {
          levelDetail.currentRate = this.shieldedText;
          levelDetail.minimum = this.shieldedText;
        }
        if (first) {
          levelDetail.txGroup = details.txGroup;
          levelDetail.txGroupDescription = details.txGroupDescription;
        }
        first = false;
        this.rowData.push(levelDetail);
      });
    });
  }
}
